import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row splitcol" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" show aggregate attention ")
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttnMap = _resolveComponent("AttnMap")!
  const _component_AggAttnMap = _resolveComponent("AggAttnMap")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ImageAttnMap = _resolveComponent("ImageAttnMap")!

  return (_ctx.modelType == 'bert' || _ctx.modelType == 'gpt-2')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["row", { splitcol: _ctx.showAgg }])
        }, [
          _createVNode(_component_AttnMap, {
            myID: 'sentAttn',
            otherID: 'aggAttn'
          })
        ], 2),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_2, [
              _createVNode(_component_AggAttnMap, {
                myID: 'aggAttn',
                otherID: 'sentAttn'
              })
            ], 512), [
              [_vShow, _ctx.showAgg]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_a_button, {
              id: "show-agg",
              type: "primary",
              onClick: $setup.showAggAttention
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"]), [
              [_vShow, !_ctx.showAgg]
            ])
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode(_component_ImageAttnMap)
      ]))
}